module.exports = __webpack_public_path__ + "img/upcoming-events_olympics.542cd5e2.jpg";